<template>
  <div class="tva-row puntate-container">
    <div class="tva-col-md-12 title">
      <div class="copyright">Scopri le puntate del podcast</div>
    </div>
    <div class="tva-col-md-12 bottoni-capitoli">
      <PuntataButton
        v-for="(puntata,p) in content.puntate"
        :key="p"
        :number="puntata.capitolo"
        :puntataSelezionata="puntataSelezionata"
        v-on:childToParent="onChildClick"
      />
    </div>
    <div v-if="puntataSelezionata" class="dynamic-area">
      <div class="tva-col-md-6 title" v-html="content.puntate[puntataSelezionata-1].titolo"></div>
      <div class="tva-col-md-6 incipit">
        <!-- <div class="caption">Incipit</div> -->
        <div class="text" v-html="content.puntate[puntataSelezionata-1].incipit"></div>
      </div>
    </div>
  </div>
</template>
<script>
import gsap from "gsap";
import { TimelineMax } from 'gsap'
import PuntataButton from "@/components/PuntataButton.vue";
export default {
  props: ["content"],
  data() {
    return {
      puntataSelezionata: 1
    };
  },
  watch:{
  },
  mounted() {
    this.onChildClick (1)
  },
  computed: {
  },
  methods: {
    onChildClick (value) {
      this.puntataSelezionata = value
    }
  },
  components: {
    PuntataButton
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/bootstrap-grid.scss";
@import "@/assets/scss/fonts.scss";
.puntate-container{
  .title{
    display: flex;
    justify-content: center;
    padding-top: 150px;
    @include mdf-copyright;
  }
  .bottoni-capitoli{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 70px;
    .btn-capitolo{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      border: 2px solid $mdf-white;
      border-radius: 50%;
      cursor: pointer;
      &:hover{
        background-color: $mdf-white;
        span{
          color: $mdf-lightblue;
        }
      }
      span{
        color: $mdf-white;
        font-family: Montserrat;
        font-size: 24px;
        font-weight: 500;
        letter-spacing: 1.5px;
        text-align: center;
        padding-left: 2px;
      }
    }
    .btn-capitolo.selected{
      background-color: $mdf-white;
        span{
          color: $mdf-darkblue;
        }
    }
  }
  .dynamic-area{
    display: flex;
    flex-direction: row;
    .title{
      @include mdf-puntate-title;
    }
    .incipit{
      padding-top: 100px;
      @include mdf-puntate-incipit;
      .caption{
        font-size: 14px;
        font-weight: 600;
      }
      .text{
        padding-top: 24px; 
      }
    }
  }
}
/* Smartphones (portrait and landscape) ----------- */
@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
  .puntate-container{
    align-items: center;
    padding-top: 72px;
    .bottoni-capitoli{
      flex-wrap: wrap;
      justify-content: center;
      padding-top: 35px;
    }
    .dynamic-area{
      display: block;
      .title{
        font-size: 30px;
        padding-top: 24px;
        line-height: 40px;
      }
      .incipit{
        padding-top: 24px;
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
}
</style>
